import { BreadcrumbLink } from '@Components/Breadcrumb';
import { Messages } from '@Config/messages';
import { RouteConfig } from '@Config/routes';
import { AdvertFragment, AuctionFragment } from '@Graphql/graphqlTypes.generated';
import { buildCategoryPageOnCategoriesUrl } from '@Utils/router';
import { Translator } from '@Utils/translation';
import { TranslationSelector } from '@Utils/types';

export const buildAuctionBreadCrumbLinks = (
  auction: AuctionFragment,
  isMyAuction: boolean,
  t: Translator,
  selectTranslation: TranslationSelector,
): BreadcrumbLink[] => {
  // TODO how to build urls for auctions and myAuctions (owner won't work)
  return [
    {
      id: 'auction',
      link: isMyAuction ? RouteConfig.MyAuctions.buildLink() : RouteConfig.Auctions.buildLink(),
      title: t(Messages.auctionBreadcrumb),
    },
    {
      id: auction.category.id,
      link: RouteConfig.Auctions.buildLink(), // TODO change to category related link
      title: selectTranslation(auction.category.name),
    },
    {
      id: auction.id,
      link: isMyAuction
        ? RouteConfig.MyAuctionPreview.buildLink({ slug: auction.slug })
        : RouteConfig.AuctionPreview.buildLink({ slug: auction.slug }),
      title: auction.title,
    },
  ];
};

export const buildAdvertBreadCrumbLinks = (
  advert: AdvertFragment,
  t: Translator,
  selectTranslation: TranslationSelector,
): BreadcrumbLink[] => {
  return [
    { id: 'marketplace', link: RouteConfig.Marketplace.buildLink(), title: t(Messages.marketPlace) },
    {
      id: advert.category.id,
      link: buildCategoryPageOnCategoriesUrl(advert.category.slug),
      title: selectTranslation(advert.category.name),
    },
    {
      id: advert.id,
      link: RouteConfig.Advert.buildLink({ slug: advert.slug }),
      title: advert.title,
    },
  ];
};
